import simplebar from 'simplebar';

let simpleBar = null;
let simpleBarMenu = null;

export function initSimplebar(container) {
	const $articleContent = $(container).find('.article-content');
	const $articleScroll = $(container).find('#article-scroll')[0];
	const $header = $(container).find('.header');
	const positionTop = parseInt($articleContent.css('margin-top')) / 4;

	simpleBar = new simplebar($articleScroll);
	simpleBar.getScrollElement().addEventListener('scroll', function(){
		let x = $(this).scrollTop();
		if( x >= positionTop ) {
			$header.addClass('is-dark');
		} else {
			$header.removeClass('is-dark');
		}
	});


	// simpleBar for menu popup
	const $menuScroll = $(container).find('#menu-scroll')[0];
	simpleBarMenu = new simplebar($menuScroll);
}

export function destroySimplebar() {
	if (simpleBar) {
		simpleBar.unMount();
	}

	if (simpleBarMenu) {
		simpleBarMenu.unMount();
	}
}
